import { useSuspenseGetFupAdditionalFields } from "@api";
import type { IFup } from "@bbj-types/socialApply/fup";
import { Stack } from "@mui/material";
import { LabelInfo, SuspenseHandler } from "@styleguide";
import { VisualizeBeneficiaryFields } from "./beneficiaryAdditionnal";
import { VisualizeBeneficiaryAdmin } from "./beneficiaryAdmin";
import { VisualizePrescription } from "./prescription";

interface IFormVisualizeProps {
  fup: IFup;
}

export const FormVisualize = ({ fup }: IFormVisualizeProps) => {
  const getFupAdditionalFields = useSuspenseGetFupAdditionalFields();

  return (
    <Stack
      sx={{
        gap: 4,
      }}
    >
      <LabelInfo label="Nom de l'offre sollicitée" text={fup.name} />
      <VisualizeBeneficiaryAdmin beneficiary={fup.beneficiary} />
      <SuspenseHandler>
        <VisualizeBeneficiaryFields
          beneficiaryAdditionalFields={fup.beneficiary.additionalFields}
          getFupAdditionalFields={getFupAdditionalFields}
        />
      </SuspenseHandler>
      <VisualizePrescription prescription={fup.prescription} />
    </Stack>
  );
};
